import { render, staticRenderFns } from "./PurchaseAnalysis.vue?vue&type=template&id=6c4cf26f&scoped=true&"
import script from "./PurchaseAnalysis.vue?vue&type=script&lang=js&"
export * from "./PurchaseAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseAnalysis.vue?vue&type=style&index=0&id=6c4cf26f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4cf26f",
  null
  
)

export default component.exports